export const environment = {
  production: false,
  apiUrl: 'https://api-dev-fabota.infano.io',
  auth: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_WEOWJHJOQ',
    webClientId: '5k92eoiopiin151ebsqcdqjjhi',
  },
};
